module.exports = __webpack_public_path__ + "static/media/header-hero.d32df65f.png";